export default __webpack_public_path__ + "static/media/openDot.71e13f5d.svg";